import React from 'react';
import { ReferenceUnavailable } from 'components/ReferenceUnavailableBox/ReferenceUnavailable';
import { Flex } from 'UI';

interface UnavailableBoxProps {
  message: string;
  extraLarge: boolean;
}

export const UnavailableBox = ({ message, extraLarge }: UnavailableBoxProps) => (
  <Flex minWidth={extraLarge ? 400 : 185} maxWidth={400} align="center" justify="flex-end">
    <ReferenceUnavailable size="medium" message={message} />
  </Flex>
);
